<template>
  <layout>
    <!--总统计区-->
    <template v-slot:pageTab>
      <div class="headerA flex-center">
        <div class="flex-center-col">
          <font class="fontColor">运输船舶</font>
        </div>
      </div>
      <div class="headerB flex-between">
        <div class="flex-center-y">
          <dl class="item">
            <dt class="bigNumber flex-center-y">
              <div class="danwei">平台注册<br />船舶数量</div>
              <div class="num flex-center">
                <span v-for="(item, index) in $numToArr(total.pageCount || 0)" :key="index">
                  <font>{{ item }}</font>
                </span>
              </div>
              <div class="danwei">艘</div>
            </dt>
          </dl>
        </div>
      </div>
    </template>
    <!--总统计区 end-->

    <!--搜索及功能区-->
    <template v-slot:pageSearch>
      <ul class="tab">
        <li>
          <Input size="small" v-model="searchMap.keyword" placeholder="船舶编号/经营人手机" style="width: 250px" />
        </li>
        <li>
          <Button type="warning" size="small" @click="search">查询</Button>
        </li>
      </ul>
    </template>
    <!--搜索及功能区 end-->

    <!--主体呈现区-->
    <template v-slot:pageContent>
      <QHTable :total="total['pageCount'] || 0" :pageThis="pageThis">
        <Table :columns="columns" :data="list" @on-selection-change="(event) => $tableSeletChange(event, pageThis)" :loading="loading" class="QHTableList">
          <!--分割区-->
          <template slot-scope="{ row }" slot="status">
            <Tag color="cyan" v-if="row.status == 100">使用中</Tag>
            <Tag color="red" v-if="row.status == 200">未使用</Tag>
          </template>

          <!--分割区-->
          <template slot-scope="{ row }" slot="allQualificationsCount">
            <b style="font-size: 18px; color: #01aaed" v-if="row.allQualificationsCount > 0">{{ row.allQualificationsCount }}</b>
            <b style="font-size: 18px; color: #bbb" v-if="row.allQualificationsCount == 0">{{ row.allQualificationsCount }}</b>
            <b style="color: #bbb">/</b>
            <b style="font-size: 18px; color: #ed4014" v-if="row.invalidQualificationsCount > 0">{{ row.invalidQualificationsCount }}</b>
            <b style="font-size: 18px; color: #bbb" v-if="row.invalidQualificationsCount == 0">{{ row.invalidQualificationsCount }}</b>
          </template>

          <!--分割区-->
          <template slot-scope="{ row }" slot="action">
            <Button type="warning" size="small" @click="$refs.detailed.hiPop(row)">详情</Button>
          </template>
        </Table>
      </QHTable>
    </template>
    <!--主体呈现区 end-->

    <!--弹窗组件区-->
    <template v-slot:pageBlock>
      <detailed ref="detailed"></detailed>
    </template>
    <!--弹窗组件区 end-->
  </layout>
</template>
<script>
import detailed from "./block/detailed/detailed";
export default {
  components: {
    detailed,
  },
  data() {
    return {
      //列表配置项(loading加载效果,columns列,list数据,selectedRows选中,total统计项)@@@@@@@@@@@
      list: [],
      pageThis: this,
      loading: false,
      selectedRows: [],
      total: {},
      columns: this.$colFilter([
        {
          title: "船舶编号",
          key: "shipCode",
          width: 120,
          align: "center",
        },
        {
          title: "船舶名称",
          key: "name",
          width: 120,
          align: "center",
        },
        {
          title: "船舶载量",
          key: "capacity",
          width: 120,
          align: "center",
        },
        {
          title: "船舶登记号",
          key: "registrationNumber",
          width: 150,
          align: "center",
        },
        {
          title: "船检登记号",
          key: "inspectionRegistrationNumber",
          width: 150,
          align: "center",
        },
        {
          title: "船舶所有人",
          key: "owner",
          width: 220,
          align: "center",
        },
        {
          title: "船舶经营人",
          key: "operator",
          width: 220,
          align: "center",
        },
        {
          title: "经营人手机",
          key: "phoneNumber",
          width: 130,
          align: "center",
        },
        {
          title: "经营人许可证号码",
          key: "licenseNumber",
          width: 150,
          align: "center",
        },
        {
          title: "有效期截止",
          key: "validityPeriod",
          width: 150,
          align: "center",
          render: (h, parameter) => {
            var row = parameter.row;
            let time = this.$timeFmt(row.validityPeriod, "YYYY-MM-DD");
            return h("span", time);
          },
        },
        {
          title: "船舶总长",
          key: "totalLength",
          width: 120,
          align: "center",
        },
        {
          title: "船长",
          key: "length",
          width: 100,
          align: "center",
        },
        {
          title: "船宽",
          key: "width",
          width: 100,
          align: "center",
        },
        {
          title: "型深",
          key: "depth",
          width: 100,
          align: "center",
        },
        {
          title: "最大船高",
          key: "maxHeight",
          width: 120,
          align: "center",
        },
        {
          title: "空载吃水",
          key: "lightDraft",
          width: 120,
          align: "center",
        },
        {
          title: "满载吃水",
          key: "fullDraft",
          width: 120,
          align: "center",
        },
        {
          title: "创建时间",
          key: "created",
          width: 135,
          align: "center",
          render: (h, parameter) => {
            var row = parameter.row;
            let time = this.$timeFmt(row.created, "YYYY-MM-DD HH:mm");
            return h("span", time);
          },
        },
        {
          title: "资质/异常",
          width: 100,
          align: "center",
          fixed: "right",
          slot: "allQualificationsCount",
        },
        {
          title: "操作",
          key: "action",
          fixed: "right",
          width: 80,
          slot: "action",
          align: "center",
        },
      ]),
      searchMap: {
        keyword: "",
        status: 100,
        pageNo: 1,
        pageSize: 25,
      },
      //其他逻辑配置项@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@
      dataLoading: false,
      dataName: "",
      total: "",
    };
  },

  // +----------------------------------------------------------------------
  // | mounted
  // +----------------------------------------------------------------------
  mounted() {
    this.getList();
  },

  methods: {
    // +----------------------------------------------------------------------
    // | 列表
    // +----------------------------------------------------------------------
    getList() {
      var that = this;
      var parameter = this.searchMap;
      var https = {
        type: "isPagelist",
        api: this.$api.getShipList,
        parameter: parameter,
      };
      this.$httpsApi(https, function (res) {
        that.total = res.count;
        that.dataLoading = true;
      });
    },

    // +----------------------------------------------------------------------
    // | 搜索
    // +----------------------------------------------------------------------
    search(status) {
      if (!this.$isblank(status)) {
        this.searchMap.status = status;
      }
      this.searchMap.pageNo = 1;
      this.getList();
    },
  },
};
</script>
<style>
.pageSearch {
  width: 100% !important;
  left: 0;
}
.pageContent {
  width: 100% !important;
  left: 0;
}
.QHPage {
  left: 0;
}
</style>
